<template>
  <div class="menuTop">
    <router-link
      :to="{ name: PAGE_NAME.HOME }"
      class="menuTop_item"
      :class="{ '-active': isActiveHome }"
      data-analytics
      data-analytics-element-type="menu_top"
      :data-analytics-element-target="{ name: PAGE_NAME.HOME }"
      :data-analytics-element-id="PAGE_NAME.HOME"
      :data-analytics-element-name="$t('crumb.general')"
    >
      {{$t('crumb.general')}}
    </router-link>
    <router-link
      :to="{ name: PAGE_NAME.SUPPORT }"
      class="menuTop_item"
      :class="{ '-active': isActiveSupport }"
      data-analytics
      data-analytics-element-type="menu_top"
      :data-analytics-element-target="{ name: PAGE_NAME.SUPPORT }"
      :data-analytics-element-id="PAGE_NAME.SUPPORT"
      :data-analytics-element-name="$t('supportCenter')"
    >
      {{ $t('supportCenter') }}
    </router-link>
    <router-link
      :to="{ name: PAGE_NAME.SUBSCRIPTIONS }"
      class="menuTop_item"
      :class="{ '-active': isActiveSubscriptions }"
      data-analytics
      data-analytics-element-type="menu_top"
      :data-analytics-element-target="{ name: PAGE_NAME.SUBSCRIPTIONS }"
      :data-analytics-element-id="PAGE_NAME.SUBSCRIPTIONS"
      :data-analytics-element-name="$t('Subscriptions')"
    >
      {{ $t('Subscriptions') }}
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import PAGE_NAME from '@web/consts/PAGE_NAME'
import { useMenuActiveSection } from '@web/composition/useMenuActiveSection'

defineOptions({
  name: 'MenuTop'
})

const { isActiveHome, isActiveSupport, isActiveSubscriptions } = useMenuActiveSection()
</script>

<style lang="scss" scoped>
@import '@web/assets/scss/textContsnts.scss';
.menuTop {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 38px;

  &_item {
    padding: 9px 0;
    border: 1.5px solid transparent;
    @extend .text-sm;
    color: var(--ac-color-deep-navy-blue);
    text-decoration: none;

    &.-active {
      border-bottom-color: var(--ac-color-liliac-accent);
    }

    &:hover:not(&.-active) {
      color: var(--ac-color-deep-liliac);
      @extend .text-sm-medium;
    }
  }
}
</style>
